import { createStore } from 'vuex'

export default createStore({
  state: {
    income: null,
    nChild: null,
    nChildUp: null,
    location: null,
    range: 0,
    diploma: null
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
